import { Types } from "../../constants/index.js";
export default (({
  objectType,
  editable = false,
  creatable = true,
  editOptions,
  createOptions
}) => {
  return {
    name: 'deviceTypeId',
    objectType,
    valueType: 'string',
    get: (data, cxt) => {
      return data?.deviceTypeId;
    },
    set: (data, value, cxt) => {
      return {
        ...data,
        deviceTypeId: value
      };
    },
    canSet: () => true,
    getPatch: (data, value, cxt) => {
      return {
        path: 'deviceTypeId',
        value
      };
    },
    displayName: 'Device Type Id',
    source: {
      type: Types.apiName,
      targetType: Types.deviceType,
      editable,
      creatable,
      editOptions: {
        editor: 'fotaItemSelector',
        label: 'Device Type',
        ...editOptions
      },
      createOptions: {
        editor: 'fotaItemSelector',
        label: 'Device Type',
        ...createOptions
      }
    }
  };
});